import axios from 'axios';
import ServerProperties from '../../config/server.js'
import {RequestinProcess,AddPaginationURL} from '../../helper/request.action.js'
let result = []
export default {
  Register: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API+'Master/AssetStatus/Register/',
      {
        Name:params.data.Name,
        Description : params.data.Description,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self, response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
      console.error("error on register asset status!");
    });
  },
  Update: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Master/AssetStatus/Update/'+params.data.Alias+'/',
      {
        Name:params.data.Name,
        Description : params.data.Description,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
      console.error("error on update asset status!");
    });
  },
  Delete: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Master/AssetStatus/Delete/'+params.data.Alias+'/',
      {
          Name:params.data.Name,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
      console.error("error on delete asset status!");
    });
  },
  Read: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'Master/AssetsStatus/?search='+params.data.query: params.data.url,
      {
      }
    )
    .then(function (response) {
      if(params.action === 'Next'){
        result = result.concat(response.data.results)
      }else{
        result = response.data.results
      }
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("MasterAssetStatusSetRS",{next:response.data.next,previous:response.data.previous,rs:result,query:params.data.query}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("MasterAssetStatusSetRS",{next:null,previous:null,rs:[],query:''}))
      // params.onfailed(error.response.data)
      console.error("error on read asset status master!");
    });
  },
  ReadAsMaster: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API+'Master/AssetsStatus/Master/',
      {
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false, type:null}))
      params.RunRedux(AddPaginationURL("MasterAssetStatusSetRS",{next:null,previous:null,rs:response.data,query:''}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false, type:null}))
      params.RunRedux(AddPaginationURL("MasterAssetStatusSetRS",{next:null, previous:null, rs:[], query:''}))
      console.error("error on read master asset status!");
      // params.onfailed(error.response.data)
    });
  },
}



// WEBPACK FOOTER //
// ./src/App/master/asset_status/model.js